import styled from "styled-components";
import {Typography, Table, Collapse} from "antd";

const {Text} = Typography;

export const PageWrapper = styled.div`
    padding: 20px;
    width: 100%;
`;

export const StyledTable = styled(Table)`
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
`;

export const StyledCollapse = styled(Collapse)`
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 10px;
    width: 100%;
`;

export const HeaderWrapper = styled.div`
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

export const DateWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
`;

export const DetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;

export const DetailLabel = styled(Text)`
    font-weight: bold;
    flex: 0 0 120px;
`;

export const DetailValue = styled(Text)`
    text-align: right;
    flex: 1;
    word-wrap: break-word;
    word-break: break-word;
    max-width: 70%;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 15px;
`;

export const EmptyWrapper = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 40px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AccountButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    z-index: 1000;
`;

export const PaymentTypeContainer = styled.div`
    border: 1px solid #aef001;
    border-radius: 4px;
    margin-bottom: 8px;
    background-color: white;
`;

export const PaymentTypeRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #fafafa;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #f0f0f0;
    }
`;

export const PaymentTypeInfo = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const PaymentTypeLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
`;

export const PaymentTypeCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    text-align: center;
`;

export const PaymentTypeRight = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
    justify-content: flex-end;
`;

export const OrderDetailHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background-color: #f5f5f5;
    font-weight: bold;
    border-bottom: 1px solid #e8e8e8;
`;

export const OrderDetailSection = styled.div`
    background-color: white;
`;

export const OrderDetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background-color: white;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;
